<template>
  <div class="invoice-form-summary">
    <div class="summary-items-container">
      <div class="summary-item">
        <h4>Subtotal</h4>
        <span>${{ this.subtotal.toFixed(2) }}</span>
      </div>
      <div class="summary-item">
        <h4>Deductions <button type="button" @click="toggleDeductionsForm" class="button" role="button">Edit</button></h4>
        <span>${{ form.deductions ? Number(form.deductions).toFixed(2) : Number(0).toFixed(2) }}</span>
      </div>
      <div class="summary-item">
        <h4>Tax ({{ form.taxRate ? form.taxRate : 0 }}%) <button type="button" @click="toggleTaxForm" class="button" role="button">Edit</button></h4>
        <span>${{ this.calculatedTax.toFixed(2) }}</span>
      </div>
    </div>
    <div id="deductions-form" class="summary-items-container" :class="{ active: deductionsFormActive }">
      <div class="field">
        <label class="label input-wrapper active">
          <span class="input-label">Deductions ($)</span>
          <input v-model="form.deductions" v-validate="'decimal:2'" data-vv-as="deductions" name="deductions" type="number" class="input" placeholder="Deduction Amount">
          <span class="form-messages">{{ errors.first('deductions') }}</span>
        </label>
      </div>
    </div>
    <div id="tax-rate-form" class="summary-items-container" :class="{ active: taxFormActive }">
      <div class="field">
        <label class="label input-wrapper active">
          <span class="input-label">Tax Rate (%)</span>
          <input v-model="form.taxRate" v-validate="'between:0,100'" data-vv-as="tax rate" name="tax_rate" type="number" class="input" placeholder="Tax Rate">
          <span class="form-errors">{{ errors.first('tax_rate') }}</span>
        </label>
      </div>
    </div>
    <div class="summary-items-container">
      <div class="summary-item">
        <h4>Total</h4>
        <span>${{ this.calculatedTotal.toFixed(2) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoiceFormSummary',
  props: {
    form: {
      type: Object,
      required: true
    },
    subtotal: {
      type: Number,
      default: 0
    },
    tax: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      deductionsFormActive: false,
      taxFormActive: false
    }
  },
  computed: {
    calculatedTax: function () {
      if (this.subtotal && this.form.taxRate) {
        return (this.subtotal.toFixed(2) * Number(this.form.taxRate).toFixed(2) * 0.01)
      } else {
        return 0
      }
    },
    calculatedTotal: function () {
      return this.subtotal + this.calculatedTax - this.form.deductions
    }
  },
  methods: {
    toggleDeductionsForm () {
      this.deductionsFormActive = !this.deductionsFormActive
    },
    toggleTaxForm () {
      this.taxFormActive = !this.taxFormActive
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/Variables.scss';

.invoice-form-summary {
  border: 1px solid $grey;
  border-radius: 4px;
  flex: 1 1 100%;
  margin-bottom: 2rem;
  padding: 1rem;
  width: 100%;
  .summary-items-container {
    &:not(:last-child) {
      border-bottom: 1px solid $grey;
      padding-bottom: .5rem;
    }
    &:last-child {
      padding-top: .5rem;
    }
    .summary-item {
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .button {
        color: $blue-dream;
        font-size: .875rem;
        font-weight: normal;
        text-decoration: underline;
        &:hover {
          color: $la-confidential;
        }
      }
    }
  }
  #tax-rate-form,
  #deductions-form {
    display: none;
    .field {
      .label.input-wrapper {
        margin-top: 15px;
        width: 100%;
      }
    }
  }
  #tax-rate-form.active,
  #deductions-form.active {
    display: block;
  }
}

@media (min-width: 768px) {
  .invoice-form-summary {
    flex: 1 1 50%;
    margin-top: 33px;
  }
}
</style>
